var cov_1lfxde0hvx = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Pagination/index.tsx",
      hash = "0bdd17213da6503b43029d78fa0d1532be1ab252",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Pagination/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 21
        },
        end: {
          line: 5,
          column: 66
        }
      },
      "1": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 16
        }
      },
      "2": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 93
        }
      },
      "3": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 52
        }
      },
      "4": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 30,
          column: 5
        }
      },
      "5": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 85
        }
      },
      "6": {
        start: {
          line: 34,
          column: 23
        },
        end: {
          line: 34,
          column: 55
        }
      },
      "7": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 40
        }
      },
      "8": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 38,
          column: 5
        }
      },
      "9": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 56
        }
      },
      "10": {
        start: {
          line: 42,
          column: 20
        },
        end: {
          line: 42,
          column: 60
        }
      },
      "11": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 42
        }
      },
      "12": {
        start: {
          line: 43,
          column: 31
        },
        end: {
          line: 43,
          column: 42
        }
      },
      "13": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 119
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 38
          },
          end: {
            line: 24,
            column: 3
          }
        },
        line: 18
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        loc: {
          start: {
            line: 26,
            column: 49
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 26
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 64
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 33
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        },
        loc: {
          start: {
            line: 41,
            column: 11
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 41
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 28
          },
          end: {
            line: 21,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 28
          },
          end: {
            line: 21,
            column: 41
          }
        }, {
          start: {
            line: 21,
            column: 45
          },
          end: {
            line: 21,
            column: 65
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        }, {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        }],
        line: 27
      },
      "2": {
        loc: {
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 27,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 27,
            column: 48
          }
        }, {
          start: {
            line: 27,
            column: 52
          },
          end: {
            line: 27,
            column: 94
          }
        }],
        line: 27
      },
      "3": {
        loc: {
          start: {
            line: 33,
            column: 32
          },
          end: {
            line: 33,
            column: 62
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 33,
            column: 43
          },
          end: {
            line: 33,
            column: 62
          }
        }],
        line: 33
      },
      "4": {
        loc: {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }, {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }],
        line: 36
      },
      "5": {
        loc: {
          start: {
            line: 42,
            column: 20
          },
          end: {
            line: 42,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 20
          },
          end: {
            line: 42,
            column: 38
          }
        }, {
          start: {
            line: 42,
            column: 42
          },
          end: {
            line: 42,
            column: 60
          }
        }],
        line: 42
      },
      "6": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 42
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 42
          }
        }],
        line: 43
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Pagination/index.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Pagination from './Pagination';
var DefaultValue = (cov_1lfxde0hvx.s[0]++, {
  defaultCurrent: 1,
  pageSize: 10,
  total: 0
});

var _default =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(_default, _PureComponent);

  var _super = _createSuper2(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    cov_1lfxde0hvx.f[0]++;
    cov_1lfxde0hvx.s[1]++;
    _this = _super.call(this, props); // @ts-ignore

    cov_1lfxde0hvx.s[2]++;
    _this.state = {
      current: (cov_1lfxde0hvx.b[0][0]++, props.current) || (cov_1lfxde0hvx.b[0][1]++, props.defaultCurrent),
      pageSize: props.pageSize
    };
    cov_1lfxde0hvx.s[3]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_1lfxde0hvx.f[1]++;
      cov_1lfxde0hvx.s[4]++;

      if ((cov_1lfxde0hvx.b[2][0]++, prevProps.current !== this.props.current) || (cov_1lfxde0hvx.b[2][1]++, prevProps.pageSize !== this.props.pageSize)) {
        cov_1lfxde0hvx.b[1][0]++;
        cov_1lfxde0hvx.s[5]++;
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          current: this.props.current,
          pageSize: this.props.pageSize
        });
      } else {
        cov_1lfxde0hvx.b[1][1]++;
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(current) {
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1lfxde0hvx.b[3][0]++, this.state.pageSize);
      cov_1lfxde0hvx.f[2]++;
      var sizeChange = (cov_1lfxde0hvx.s[6]++, pageSize !== this.state.pageSize);
      cov_1lfxde0hvx.s[7]++;
      this.setState({
        current: current,
        pageSize: pageSize
      });
      cov_1lfxde0hvx.s[8]++;

      if (this.props.onChange) {
        cov_1lfxde0hvx.b[4][0]++;
        cov_1lfxde0hvx.s[9]++;
        this.props.onChange(current, pageSize, sizeChange);
      } else {
        cov_1lfxde0hvx.b[4][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_1lfxde0hvx.f[3]++;
      var current = (cov_1lfxde0hvx.s[10]++, (cov_1lfxde0hvx.b[5][0]++, this.props.current) || (cov_1lfxde0hvx.b[5][1]++, this.state.current));
      cov_1lfxde0hvx.s[11]++;

      if (this.props.total < 0) {
        cov_1lfxde0hvx.b[6][0]++;
        cov_1lfxde0hvx.s[12]++;
        return null;
      } else {
        cov_1lfxde0hvx.b[6][1]++;
      }

      cov_1lfxde0hvx.s[13]++;
      return (
        /*#__PURE__*/
        React.createElement(Pagination, Object.assign({}, this.props, {
          current: current,
          pageSize: this.state.pageSize,
          onChange: this.handleChange,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 45,
            columnNumber: 12
          }
        }))
      );
    }
  }]);

  return _default;
}(PureComponent);

_default.displayName = 'ShineoutPagination';
_default.defaultProps = DefaultValue;
export { _default as default };